<template>
  <div class="container" id="goods-edit">
    <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
      <el-form
        ref="form"
        label-width="110px"
        class="info-form"
        style="margin-top: 22px"
        :rules="rules"
        :model="form"
      >
        <el-form-item label="标签名称" prop="tagName">
          <el-input
            placeholder="请输入标签名称"
            v-model="form.tagName"
            style="width: 442px"
            maxlength="5"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="标签图片" prop="tagImg">
          <upload-picture
            :imageUrl="form.tagImg"
            :width="'128px'"
            :height="'128px'"
            @getUrl="getImage"
          ></upload-picture>
          <div class="messageI">
            图片尺寸：建议上传尺寸1:1，大小不得超过2M,支持jpg、jpeg、png格式
          </div>
        </el-form-item>
        <el-form-item label="标签排序" prop="sort">
          <el-input
            placeholder="请输入排序数字"
            v-model="form.sort"
            style="width: 442px"
            oninput="value=value.replace(/[^0-9]/g, '')"
          ></el-input>
          <div class="messageI">数字越大越靠后</div>
        </el-form-item>

        <el-form-item label="状态" prop="status">
          <el-select
            style="width: 442px"
            v-model="form.status"
            placeholder="请选择状态"
            filterable
            clearable
          >
            <el-option label="启用" value="true"></el-option>
            <el-option label="禁用" value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="height: 20px"></div>
      <div class="back-btn">
        <el-button type="info" @click="back">返回</el-button>
        <el-button type="primary" @click="submit">确认</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import uploadPicture from '@/components/upload/mallPicture.vue'
import uploadPicture1 from '@/components/upload/dragpicturew.vue'
export default {
  components: {
    breadcrumbTop,
    breadcrumbSearch,
    uploadPicture,
    uploadPicture1
  },
  data () {
    return {
      goodsName: '',
      fileList: [],
      goodsList: [

      ],
      dialogGoods: false,
      radio: '1',
      startTime: [],
      expireDates: [
        {
          dictId: 1,
          dictName: '一个月'
        },
        {
          dictId: 3,
          dictName: '三个月'
        },
        {
          dictId: 12,
          dictName: '一年'
        },
        {
          dictId: 0,
          dictName: '永久'
        },
      ],
      dataList: {
        list: [
          { title: '商品管理', path: '', type: '0' },
          { title: '标签管理', path: '', type: '1' }
        ]
      },
      searchList: {
        list: [
          { title: '新增标签', path: '', type: '0' }
        ]
      },
      checked1: true,
      checked2: false,
      radio: 3,
      name: '---',
      dialogUser: false,
      currentPage4: 1,
      tableData: [

      ],
      tableDataF: [

      ],
      detail: {},
      form: {
        id: '',
        tagImg: '',
        tagName: '',
        status: '',
        sort: ''
      },
      rules: {
        tagName: [
          { required: true, message: '请输入标签名称', trigger: 'blur' },
        ],
        tagImg: [
          { required: true, message: '请上传标签图片', trigger: 'change' },
        ],
        sort: [
          { required: true, message: '请输入排序数字', trigger: 'blur' },
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' },
        ],
      },
      arr: []
    }
  },
  created () {
    if (this.$route.query.id) {
      this.getDetail()
      this.searchList.list[0].title='编辑标签'
    }
  },
  methods: {
    getImage (val) {
      this.form.tagImg = val
      this.$refs.form.clearValidate('tagImg')
    },
    submit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.axios.post('/tags/save', this.form)
            .then(res => {
              console.log(res)
              if (res.code == 0) {
                this.$message.success('保存成功')
                this.$router.push({
                  name: 'tagManagement',

                })
              }
            })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    selectGoods () {
      console.log(88888888)
      this.dialogGoods = true
    },
    back () {
      this.$router.go(-1)
    },
    select () {
      console.log(this.arr)
    },
    getDetail () {
      this.axios.get('tags/get?id=' + this.$route.query.id)
        .then(res => {
          if (res.code == 0) {
            this.form = res.data
            this.form.status = String(res.data.status)
          }
        })
    },
    handleCurrentChange () {

    },
    handleSizeChange () {

    },
    handleSelectionChange () {

    }
  }
}
</script>
<style scoped lang="scss">
.messageI {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 30px;
  // margin-top: 7px;
  color: #909099;
}
.info-q {
  width: 124px;
  height: 40px;
  line-height: 40px;
  background: #ffffff;
  border: 1px solid #909099;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #909099;
  margin-right: 18px;
  cursor: pointer;
}
.info-s {
  width: 126px;
  height: 40px;
  line-height: 40px;
  background: #2d46ee;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

.search-box {
  width: 100%;
  height: 50px;
  background: #f8f8f8;
  padding: 0 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border: 1px solid #e8eaec;
  border-bottom: 0;
}

::v-deep .el-input.is-disabled .el-input__inner {
  background-color: #ebeefa;
  border-color: #c0c0cc;
  color: #c0c4cc;
  cursor: not-allowed;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  text-align: left !important;
}
.detail {
  width: 378px;
  min-height: 82px;
  background: #ebeefa;
  opacity: 1;
  border-radius: 3px;
  padding: 10px 10px;
  line-height: 30px;
  color: #303033;
}
.s-label {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 40px;
  color: #303033;
  opacity: 1;
}
.start {
  width: 10px;
  height: 10px;
  background: #13ce4b;
  border-radius: 50%;
  opacity: 1;
  margin-top: 15px;
  margin-right: 5px;
}
.end {
  width: 10px;
  height: 10px;
  background: #f63c56;
  border-radius: 50%;
  opacity: 1;
  margin-top: 15px;
  margin-right: 5px;
}
.dialog-search {
  display: flex;
  width: 46%;
  justify-content: space-between;
  margin-top: 10px;
  margin-left: 10px;
}
.back-btn {
  width: 30%;
  text-align: left;
  padding-bottom: 20px;
  .el-button {
    width: 184px;
    height: 48px;
    border-radius: 4px;
    font-size: 18px;
  }
}
</style>

